<template>
  <div class="grandstands">
    <h2>Grandstands</h2>
    <router-link
      class="more_details"
      :to="{ name: 'grandstandsPage', params: $route.params }"
      ><button type="button" class="btn btn-primary btn-lg px-4 gap-3">
        More Details
      </button></router-link
    >
  </div>
</template>

<script>
export default {
  name: "Grandstands",
};
</script>

<style lang="scss" scoped>
.grandstands {
  height: 616px;
  position: relative;
  background-image: url("~images/grandstands/img-grandstands-divider-bg.jpeg");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-family: Formula1-Display-Bold;
    font-size: 58px;
    color: #ffffff;
    text-align: center;
    text-shadow: 0 9px 4px rgba(0, 0, 0, 0.5);
    font-weight: 500;
    text-transform: uppercase;
    padding-bottom: 0.5em;
  }
}
</style>